<template>
  <div>
    <div class="content">
      <div class="title-box">
        <h3 class="pull-left">{{salesMonDetailLan.datailText}}({{queryObj.REPORT_ID}})</h3>
        <div class="pull-right" style="margin-top:12px;">
          <el-button
            @click="$router.go(-1)"
            class="preview-btn"
            round
            type="warning"
          >{{salesMonDetailLan.goback}}</el-button>
        </div>
        <div class="clear"></div>
      </div>
      <div class="panel" element-loading-spinner="el-icon-loading" v-loading="loading">
        <mtable
          :downLoadTran="downLoadTran"
          :jsonExcelAjax="jsonExcelAjax"
          :multiLanguage="salesMonDetailLan"
          :name="name"
          :thData="thData"
          :trData="trData"
          ref="table"
          v-if="trData"
        >
          <div class="monthly-detail" slot="handle">
            <div class="monthly-detail">
              <span>{{salesMonDetailLan.salesAccount}}&nbsp;{{queryObj.SALES_ID}}</span>
            </div>
            <div class="monthly-detail">
              <span>{{salesMonDetailLan.commissionType}}&nbsp;{{queryObj.type}}</span>
            </div>
            <div class="monthly-detail" v-if="isLower">
              <el-switch
                :active-text="salesMonDetailLan.spread"
                :inactive-text="salesMonDetailLan.fold"
                @change="actionChange"
                active-color="#3F51B5"
                v-model="action"
              ></el-switch>
            </div>
          </div>
        </mtable>
      </div>
    </div>
  </div>
</template>
<script>
import mtable from '../../comm/mytable'
import { URL_SALEMONTHLYCOMMDET } from 'api/commissionApi'
import { Api } from 'api/commissionEnv'
let api = new Api()

export default {
  name: 'monthCommDetailResult',
  mixins: [
    require('common/mixin/base.js').base({
      salesMonDetailLan: 'salesMonthlyResult'
    }),
    require('common/mixin/base.js').base({ publicLan: 'publicLan' })
  ],
  props: ['curArea'],
  data() {
    return {
      trData: [],
      queryObj: {},
      url: '',
      action: false,
      isLower: true,
      loading: true,
      keys: []
    }
  },
  mounted() {
    this.queryObj = this.$route.query
    if (this.queryObj.TYPE == 1) this.isLower = false
    this.tableAjax()
  },
  methods: {
    actionChange(value) {
      this.action = value
      this.tableAjax()
    },
    tableAjax() {
      this.loading = true;
      this.url = api.getUrl20(this.curArea,URL_SALEMONTHLYCOMMDET)
      let tableObj = {
        params: {
          type: this.queryObj.TYPE,
          sales_id: this.queryObj.SALES_ID,
          report_id: this.queryObj.REPORT_ID
        }
      }
      if (this.queryObj.TYPE == 0) {
        tableObj.params.isExpand = this.action
        this.$http.get(this.url, tableObj).then(res => {
          this.trData = res.data.data
          if (this.trData.length > 1) {
            this.keys = this.trData[0].length == 0 ? Object.keys(this.salesMonDetailLan.detailTh) : Object.keys(this.trData[0][0])
            this.setOfficeState()
          }
          this.loading = false
        })
        return
      }
      this.$http.get(this.url, tableObj).then(res => {
        this.trData = res.data.data
        this.setOfficeLevel()
        this.loading = false
      })
    },
    setOfficeLevel() {
      if (Object.prototype.toString.call(this.trData) == '[object Array]') {
        this.trData.forEach((item, index) => {
          let temp = this.trData[index]
          temp.level = temp.LEVEL ? this.salesMonDetailLan.levelObj[temp.LEVEL] : ''
          temp.client_type = temp.CLIENT_TYPE || temp.CLIENT_TYPE == 0 ? this.salesMonDetailLan.client_type[temp.CLIENT_TYPE] : ''
          temp.rule_id = temp.RULE_ID ? this.publicLan.rule[temp.RULE_ID] : ''
          if (index == this.trData.length - 1) temp.sub_sales_id = this.salesMonDetailLan.total[temp.SUB_SALES_ID]
          else temp.sub_sales_id = temp.SUB_SALES_ID
        })
      }
    },
    setOfficeState() {
      if (Object.prototype.toString.call(this.trData) == '[object Array]') {
        this.trData.forEach((item, index) => {
          let arr = this.trData[index]
          arr.forEach((obj, under) => {
            let temp = arr[under]
            if (under == arr.length - 2) {
              temp.ib_id = this.salesMonDetailLan.detailTotal[temp.IB_ID]
              temp[this.keys[2].toLowerCase()] = this.salesMonDetailLan.detailTotal[temp[this.keys[2]]]
              temp[this.keys[4].toLowerCase()] = this.salesMonDetailLan.detailTotal[temp[this.keys[4]]]
            } else {
              temp.ib_id = temp.IB_ID
              temp[this.keys[2].toLowerCase()] = temp[this.keys[2]]
              temp[this.keys[4].toLowerCase()] = temp[this.keys[4]]
            }
          })
          if (index === this.trData.length - 1) {
            arr[0].ib_id = this.queryObj.SALES_ID + this.salesMonDetailLan.detailTotal[arr[0].IB_ID]
          }
        })
      }
    },
    formaDetailTotal(detailTotal) {
      let  detailTotal_clone = Object.assign({}, detailTotal)
      detailTotal_clone['TOTAL'] = this.queryObj.SALES_ID + detailTotal['TOTAL']
      return detailTotal_clone
    },
  },
  computed: {
    thData() {
      if (this.queryObj.TYPE == 0) {
        let arr = []
        for (let v of this.keys) {
          let obj = {}
          obj.key = v
          obj.name = this.publicLan.detailTh[v]
          arr.push(obj)
        }
        if (arr.length != 0) {
          arr[0].key = arr[0].key.toLowerCase()
          arr[2].key = arr[2].key.toLowerCase()
          arr[4].key = arr[4].key.toLowerCase()
        }
        return arr
      }
      return this.salesMonDetailLan.lowerTh
    },
    name() {
      return this.salesMonDetailLan.datailText
    },

    downLoadTran() {
      if (this.queryObj.TYPE == 0) {
        const detailTotal = this.formaDetailTotal(this.salesMonDetailLan.detailTotal)
        let dlObj = { IB_ID: detailTotal }
        dlObj[this.keys[2]] = detailTotal
        dlObj[this.keys[4]] = detailTotal
        return dlObj
      }
      return {
        LEVEL: this.salesMonDetailLan.levelObj,
        RULE_ID: this.publicLan.rule,
        CLIENT_TYPE: this.salesMonDetailLan.client_type,
        SUB_SALES_ID: this.salesMonDetailLan.total
      }
    },
    jsonExcelAjax() {
      let excelObj = {
        url: this.url,
        ajaxType: 'get',
        getKey: ['data', 'data'],
        rID: this.queryObj.REPORT_ID,
        cID: this.queryObj.SALES_ID,
        type: this.salesMonDetailLan.typeList[this.queryObj.TYPE],
        ajaxPar: {
          type: this.queryObj.TYPE,
          sales_id: this.queryObj.SALES_ID,
          report_id: this.queryObj.REPORT_ID
        }
      }
      if (this.queryObj.TYPE == 0) {
        excelObj.ajaxPar.isExpand = this.action
      }
      return excelObj
    }
  },
  watch: {
    salesMonDetailLan() {
      this.queryObj.type = this.salesMonDetailLan.typeList[this.queryObj.TYPE]
      if (this.queryObj.TYPE == 0) this.setOfficeState()
      else this.setOfficeLevel()
    },
    curArea() {
      this.$router.push('saleMonthlyResult')
    }
  },
  components: {
    mtable
  }
}
</script>
<style lang="scss" type="text/scss" scoped>
.title-box {
  border: 1px solid #3f51b5;
  background: #3f51b5;
  padding: 0 20px;
  color: #fff;
  border-radius: 5px 5px 0 0;
  .preview-btn {
    border: 1px solid #f08712;
    background-color: #f08712;
    border-radius: 5px;
  }
}
.monthly-detail {
  float: left;
  margin-right: 50px;
}
</style>



// WEBPACK FOOTER //
// saleMonCommDetailResult.vue?cfb8305e